/**
 * @Author:
 * @Description:
 * @DateTime: Created in 14:51 2020/10/8
 */

import Api from "./api";
import {Result} from "../types/base";
import _ from 'lodash'

export namespace PublicApiI {
    export interface DivisorI{
        name: string
        key: string
        unit: string
    }
}


export default class PublicApi {

	/**
     * 获取省
     * @param type 
     */
	static async getProvince (): Promise<Result<{area_name: string, area_id: number}[]>> {
		return Api.post('/monitor/point/normal/province/get')
    }

    
    /**
     * 获取省
     * @param type 
     */
    static async getCity (province_id: number): Promise<Result<{area_name: string, area_id: number}[]>> {
		return Api.post('/monitor/point/normal/city/by/province/get', {province_id})
    }
    
    /**
     * 获取区
     * @param type 
     */
    static async getDistrict (city_id: number): Promise<Result<{area_name: string, area_id: number}[]>> {
		return Api.post('/monitor/point/normal/block/by/city/get', {city_id})
    }
    
    static async getAllComponent():Promise<Result<PublicApiI.DivisorI[]>> {
        return Api.post('/monitor/component/all/query')
    }
	static async getSiteStatus():Promise<Result<{is_show_sitename: 1|2}>> {
        return Api.post('/monitor/select/site_status')
    }
    static async setSiteStatus(is_show_sitename: number):Promise<Result<any>> {
        return Api.post('/monitor/set/site/status', {is_show_sitename})
    }
	
}
